// -- == //
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import EventForm from '../lib/eventForm';
import { useActions } from 'common/hooks/useActions';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import DangerButton from 'components/form/buttons/danger';
import QuestionModal from 'components/modal/question';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function EventDetailPage() {
  const params = useParams();
  const nav = useNavigate();

  const [ShowEndEventModal, setShowEndEventModal] = useState(false);

  const { eventDetailRequestAction, eventEndRequestAction } = useActions();
  const { departments } = useTypedSelector((state: any) => state.Departments);

  const { eventDetail, eventUpdate, eventUpload, eventCancel, eventChangeVisible, contributorUploadQuest } =
    useTypedSelector((state: any) => state.Events);

  useEffect(() => {
    eventDetailRequestAction(params?.id);
  }, []);

  const handleShowEndModal = () => {
    setShowEndEventModal(true);
  };

  const handleHideEndModal = () => {
    setShowEndEventModal(false);
  };

  const handleEndEvent = () => {
    eventEndRequestAction(eventDetail.data?.id, () => {
      setShowEndEventModal(false);
      nav('/panel/events');
    });
  };

  return (
    <S.Container>
      <PageTitle title="Edit Event" />
      <S.Head>
        {/*
         * Finishing an event is not the same act as saving it, so it stays
         * out of the form's action bar and keeps the page header to itself.
         */}
        <DangerButton onClick={handleShowEndModal} disabled={eventDetail.data?.status === 'End'} className="sm">
          {eventDetail.data?.status === 'End' ? 'Finished' : 'Finish event'}
        </DangerButton>
      </S.Head>
      <EventForm data={eventDetail.data} departments={departments.data} loading={eventUpdate.loading} />

      <AppLoading
        loading={
          eventDetail.loading ||
          eventUpdate.loading ||
          eventUpload.loading ||
          departments.loading ||
          eventCancel.loading ||
          eventChangeVisible.loading ||
          contributorUploadQuest.loading
        }
      />

      <QuestionModal
        handleClose={handleHideEndModal}
        show={ShowEndEventModal}
        model="delete"
        handleSuccess={handleEndEvent}
        title="Finish this event?"
        text="It stops accepting registrations and closes for everyone signed up."
        successButtonText="Finish event"
      />
    </S.Container>
  );
}
